export const DATA_ENTRY_CALCULATION_IDS = {
  WEIGHT_DISTANCE: 1,
  DISTANCE: 2,
  FUEL: 3,
};

export const hasNumericValue = (value) =>
  value !== "" && value !== null && value !== undefined;

export const isValidNonNegativeNumber = (value) =>
  hasNumericValue(value) &&
  Number.isFinite(Number(value)) &&
  Number(value) >= 0;

export const roundToFourDecimals = (value) =>
  Math.round((Number(value) + Number.EPSILON) * 10000) / 10000;

export const calculateWeightDistance = (weight, distance) => {
  if (!hasNumericValue(weight) || !hasNumericValue(distance)) return null;
  return roundToFourDecimals(Number(weight) * Number(distance));
};

export const formatWeightDistance = (weight, distance) => {
  const result = calculateWeightDistance(weight, distance);
  return result === null ? "" : result.toFixed(4);
};
